export default __webpack_public_path__ + "static/media/NEKO_normal.aff7204c.png";